/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-nested-ternary */
import './styles.css';

import { isAlmostEqualWithTolerance } from '@brands/Dashboard/MyProfile/Patient/utils/utilsFunctions';
import { selectOneReport } from '@brands/store/selectors/oneReport';
import { setMedia } from '@brands/store/slices/oneReportSlice';
import { setUploadFileMethod } from '@brands/store/slices/videoCallCredentialsSlice';
import { formatDate } from '@brands/Utils/formatDate';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button, IconButton } from '@mui/material';
import { heicTo } from 'heic-to';
import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import { Gallery } from 'react-grid-gallery';
import { FieldErrors, UseFormSetValue } from 'react-hook-form';
import { AiFillPlusCircle } from 'react-icons/ai';
import { BsPencil } from 'react-icons/bs';
import { IoClose } from 'react-icons/io5';
import { RiCloseCircleFill } from 'react-icons/ri';
import { toast } from 'react-toastify';

import { Loading } from '../../../../Components/LoadingSpinner/Loading';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useReduxHook';
import { ICase } from '../../../../services/cases/types/ICase';
import { RegisterMediaPayload } from '../../../../services/communication/registersConversationMedia';
import { AttachmentNoteState, ImageNoteState } from '../../../../services/forms/types/ImageNote';
import { ImageWithNotes } from '../../../../services/forms/types/ImageWithNotes';
import { UserProfile, UserRoleName } from '../../../../services/identity/types/UserProfile';
import { addOneReportMedia } from '../../../../services/oneReport/addOneReportMedia';
import { confirmOneReportMedia } from '../../../../services/oneReport/confirmOneReportMedia';
import { getOneReportMedia } from '../../../../services/oneReport/getOneReportMedia';
import { registerOneReportMedia } from '../../../../services/oneReport/registerOneReportMedia';
import { IOneReport } from '../../../../services/oneReport/types/IOneReport';
import { IOneReportMedia } from '../../../../services/oneReport/types/IOneReportMedia';
import { updateOneReportMedia } from '../../../../services/oneReport/updateOneReportMedia';
import { displayErrorDetails } from '../../../../Utils/displayError';
import { checkCollapsibleHeaderColor } from '../../../../Utils/getCollapsibleHeader';
import { truncateFilename } from '../../../../Utils/truncateString';
import { CASE_ATTACHMENT_ACCEPT, getUploadFileMimeType } from '@brands/Utils/caseAttachmentFiles';
import { OralHealthReportSubmit } from '../../assets/types';
import styles from '../../styles.module.scss';

type ImagesSectionProps = {
  consultationForm: OralHealthReportSubmit;
  setConsultationForm: React.Dispatch<React.SetStateAction<OralHealthReportSubmit>>;
  thisCase: ICase;
  setCase: React.Dispatch<React.SetStateAction<ICase>>;
  userInfo: UserProfile;
  setValue: UseFormSetValue<OralHealthReportSubmit>;
  errors: FieldErrors<OralHealthReportSubmit>;
  images: ImageWithNotes[];
  setImages: React.Dispatch<React.SetStateAction<ImageWithNotes[]>>;
  setEditImageNote: React.Dispatch<React.SetStateAction<ImageNoteState>>;
  setRemoveImage: React.Dispatch<React.SetStateAction<ImageNoteState>>;
  setRemoveAttachment: React.Dispatch<React.SetStateAction<AttachmentNoteState>>;
  updateSelectedImages: (updatedReport: IOneReport) => void;
  disabled?: boolean;
};

const IMAGE_FILE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'tif', 'tiff', 'jfif', 'pjpeg', 'pjp'];

const getFileExtension = (value?: string): string => {
  if (!value) return '';

  const valueWithoutQuery = value.split('?')[0].split('#')[0];
  const lastPathSegment = valueWithoutQuery.split('/').pop() || '';
  const lastDotIndex = lastPathSegment.lastIndexOf('.');

  return lastDotIndex >= 0 ? lastPathSegment.slice(lastDotIndex + 1).toLowerCase() : '';
};

const isDisplayableImage = (mimetype?: string, filename?: string, src?: string): boolean => {
  const normalizedMimetype = (mimetype || '').toLowerCase();
  if (normalizedMimetype.startsWith('image/')) return true;
  if (normalizedMimetype && normalizedMimetype !== 'application/octet-stream') return false;

  const extension = getFileExtension(filename) || getFileExtension(src);
  return IMAGE_FILE_EXTENSIONS.includes(extension);
};

const ImagesSection = ({
  consultationForm,
  setConsultationForm,
  thisCase,
  setCase,
  userInfo,
  setValue,
  errors,
  images,
  setImages,
  setEditImageNote,
  setRemoveImage,
  setRemoveAttachment,
  updateSelectedImages,
  disabled = false,
}: ImagesSectionProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const { media } = useAppSelector(selectOneReport);
  const [attachments, setAttachments] = useState<ImageWithNotes[]>([]);
  const [uploadingPhoto, setUploadingPhoto] = useState<boolean>(false);

  const isMobile = window.innerWidth < 768;

  const MAX_VISIBLE = isMobile ? images.length : 3;
  const shouldShowViewAll = !isMobile && images.length >= 6;

  const visibleImages = images.slice(0, MAX_VISIBLE);

  const editNote = (media_id: string, media_src: string, readOnly?: boolean): void => {
    setEditImageNote({
      isOpen: true,
      media_id,
      media_src,
      oneReportId: thisCase?.one_report?.id,
      readOnly,
    });
  };

  const removeReportImage = (media_id: string, media_src: string): void => {
    if (disabled) return;

    setRemoveImage({
      isOpen: true,
      media_id,
      media_src,
      oneReportId: thisCase?.one_report?.id,
    });
  };

  const loadImages = async (): Promise<void> => {
    setUploadingPhoto(true);
    if (thisCase?.one_report?.media && thisCase?.one_report.media?.length > 0) {
      const sortedOneReportMedias = thisCase.one_report.media.sort((a, b) => Number(a.id) - Number(b.id));
      const imagePromises = sortedOneReportMedias.map(async (mediaOneReport: IOneReportMedia) => {
        const mediaData = await getOneReportMedia(mediaOneReport.media_id!, userInfo.role.name);
        return {
          src: mediaData.url,
          width: 4,
          height: 3,
          filename: mediaData.filename,
          mimetype: mediaData.mimetype,
          created_at: mediaOneReport.created_at,
          customOverlay:
            checkCollapsibleHeaderColor(thisCase || '', userInfo, 'Images') === 'edit' ? (
              <Fragment key={mediaOneReport?.id}>
                <div
                  className="custom-overlay__caption"
                  style={{ zIndex: '1' }}
                  onClick={() => editNote(mediaOneReport.id!, mediaData.url, disabled)}
                >
                  Edit Note <BsPencil />
                </div>
                <span
                  className="custom-overlay__remove"
                  style={{ zIndex: '9' }}
                  onClick={() => removeReportImage(mediaOneReport.id!, mediaData.url)}
                >
                  <RiCloseCircleFill />
                </span>
              </Fragment>
            ) : checkCollapsibleHeaderColor(thisCase || '', userInfo, 'RemoveMedia') === 'editImages' ? (
              <Fragment key={mediaOneReport?.id}>
                <div
                  className="custom-overlay__caption"
                  onClick={() => editNote(mediaOneReport.id!, mediaData.url, disabled)}
                >
                  View Note <BsPencil />
                </div>
                <span
                  className="custom-overlay__remove"
                  onClick={() => removeReportImage(mediaOneReport.id!, mediaData.url)}
                >
                  <RiCloseCircleFill />
                </span>
              </Fragment>
            ) : checkCollapsibleHeaderColor(thisCase || '', userInfo, 'ViewNotes') === 'editImages' ? (
              <Fragment key={mediaOneReport?.id}>
                <div
                  className="custom-overlay__caption"
                  onClick={() => editNote(mediaOneReport.id!, mediaData.url, disabled)}
                >
                  View Note <BsPencil />
                </div>
                <span />
              </Fragment>
            ) : (
              <span />
            ),
          notes: mediaOneReport.note,
          id: mediaOneReport.id,
          isSelected: mediaOneReport.is_selected,
        };
      });

      const resolvedPromises = await Promise.all(imagePromises);

      const imageSrcs = resolvedPromises
        .filter((resolvedPromise) =>
          isDisplayableImage(resolvedPromise.mimetype, resolvedPromise.filename, resolvedPromise.src),
        )
        .map((resolvedPromise) => ({
          src: resolvedPromise.src,
          width: resolvedPromise.width,
          height: resolvedPromise.height,
          filename: resolvedPromise.filename,
          mimetype: resolvedPromise.mimetype,
          customOverlay: resolvedPromise.customOverlay,
          notes: resolvedPromise.notes,
          id: resolvedPromise.id,
          isSelected: resolvedPromise.isSelected,
          created_at: resolvedPromise.created_at,
        }));

      const attachmentSrcs = resolvedPromises
        .filter(
          (resolvedPromise) =>
            !isDisplayableImage(resolvedPromise.mimetype, resolvedPromise.filename, resolvedPromise.src),
        )
        .map((resolvedPromise) => ({
          src: resolvedPromise.src,
          width: resolvedPromise.width,
          height: resolvedPromise.height,
          filename: resolvedPromise.filename,
          mimetype: resolvedPromise.mimetype,
          notes: resolvedPromise.notes,
          id: resolvedPromise.id,
          created_at: resolvedPromise.created_at,
        }));

      setImages(imageSrcs);
      setAttachments(attachmentSrcs);
      setUploadingPhoto(false);
    } else {
      setImages([]);
      setAttachments([]);
      setUploadingPhoto(false);
    }
  };

  useEffect(() => {
    loadImages();
  }, [consultationForm.selectedImages, thisCase.one_report?.media?.length]);

  const updateAPI = async (triggerImage: IOneReportMedia): Promise<void> => {
    if (disabled) return;

    const updatedReport = await updateOneReportMedia(
      triggerImage.one_report_id || '',
      triggerImage.id || '',
      {
        is_selected: !triggerImage.is_selected,
      },
      userInfo.role.name,
    );
    setValue(
      'selectedImages',
      updatedReport.media?.filter((image) => image.is_selected),
      { shouldValidate: true },
    );
    setConsultationForm({
      ...consultationForm,
      selectedImages: updatedReport.media?.filter((image) => image.is_selected),
    });
  };

  const handleSelect = async (imageId: string): Promise<any> => {
    if (disabled) return;

    setUploadingPhoto(true);
    const selectedImage = images.find((image) => image.id === imageId);

    if (!selectedImage) {
      setUploadingPhoto(false);
      return;
    }

    const updatedCase = await updateOneReportMedia(
      thisCase?.one_report?.id,
      selectedImage.id!,
      {
        is_selected: !selectedImage.isSelected,
      },
      userInfo.role.name,
    );
    setCase({
      ...thisCase,
      one_report: updatedCase,
    });
    updateSelectedImages(updatedCase);
    setUploadingPhoto(false);
  };

  const handleClick = (index: number): any => {
    const selectedImage = images[index];

    if (!selectedImage.isSelected) {
      setEditImageNote({
        isOpen: true,
        media_src: selectedImage.src,
        media_id: selectedImage.id!,
        oneReportId: thisCase?.one_report?.id,
      });
    } else {
      const getSelectedImage = thisCase?.one_report?.media?.find(
        (oneReportImage) => oneReportImage.id === images[index].id,
      );
      if (getSelectedImage) {
        updateAPI(getSelectedImage);
      }
      const nextImages = images?.map((image, i) => (i === index ? { ...image, isSelected: !image.isSelected } : image));
      setImages(nextImages);
    }
  };

  const removeReportAttachment = (media_id: string, media_name: string): void => {
    if (disabled) return;

    setRemoveAttachment({
      isOpen: true,
      media_id,
      media_name,
      oneReportId: thisCase?.one_report?.id,
    });
  };

  const uploadFile = async (file: File): Promise<void> => {
    if (disabled || !thisCase?.one_report?.id) return;

    const mimetype = getUploadFileMimeType(file);
    const payload: RegisterMediaPayload = {
      files: [
        {
          filename: file.name,
          mimetype,
        },
      ],
    };
    try {
      const res = await registerOneReportMedia(payload, userInfo.role.name);
      const mediaId = res.files[0].upload_id;
      await fetch(res.files[0].upload_url, {
        method: 'PUT',
        body: file,
        headers: { 'content-type': mimetype },
      });
      await confirmOneReportMedia(mediaId, userInfo.role.name);
      const imageUrl = URL.createObjectURL(file);
      dispatch(
        setMedia([
          ...(media as IOneReportMedia[]),
          {
            media_id: mediaId,
            note: '',
          },
        ]),
      );
      const updatedOneReport = await addOneReportMedia(
        thisCase.one_report.id,
        {
          media_id: mediaId,
          note: '',
        },
        userInfo.role.name,
      );
      if (thisCase) {
        setCase({
          ...thisCase,
          one_report: updatedOneReport,
        });
      }
      updateSelectedImages(updatedOneReport);
      const mediaImage = updatedOneReport.media.find((specificMedia) => specificMedia?.media_id === mediaId);
      const newImages = {
        src: imageUrl,
        width: 4,
        height: 3,
        filename: file.name,
        mimetype,
        notes: '',
        id: mediaImage?.id,
        isSelected: mediaImage?.is_selected,
        created_at: moment(new Date()).toISOString(),
        customOverlay:
          checkCollapsibleHeaderColor(thisCase || '', userInfo, 'Images') === 'edit' ? (
            <Fragment key={mediaImage?.id}>
              <div
                className="custom-overlay__caption"
                style={{ zIndex: '1' }}
                onClick={() => editNote(mediaImage?.id || '', imageUrl, disabled)}
              >
                Edit Note <BsPencil />
              </div>
              <span
                className="custom-overlay__remove"
                style={{ zIndex: '9' }}
                onClick={() => removeReportImage(mediaImage?.id || '', imageUrl)}
              >
                <RiCloseCircleFill />
              </span>
            </Fragment>
          ) : checkCollapsibleHeaderColor(thisCase || '', userInfo, 'RemoveMedia') === 'editImages' ? (
            <Fragment key={mediaImage?.id}>
              <div
                className="custom-overlay__caption"
                onClick={() => editNote(mediaImage?.id || '', imageUrl, disabled)}
              >
                View Note <BsPencil />
              </div>
              <span
                className="custom-overlay__remove"
                onClick={() => removeReportImage(mediaImage?.id || '', imageUrl)}
              >
                <RiCloseCircleFill />
              </span>
            </Fragment>
          ) : checkCollapsibleHeaderColor(thisCase || '', userInfo, 'ViewNotes') === 'editImages' ? (
            <Fragment key={mediaImage?.id}>
              <div
                className="custom-overlay__caption"
                onClick={() => editNote(mediaImage?.id || '', imageUrl, disabled)}
              >
                View Note <BsPencil />
              </div>
              <span />
            </Fragment>
          ) : (
            <span />
          ),
      };
      if (isDisplayableImage(newImages.mimetype, newImages.filename, newImages.src)) {
        setImages((prevImages) => [...prevImages, newImages]);
      } else {
        setAttachments((prev) => [...prev, newImages]);
      }
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
  };

  useEffect(() => {
    dispatch(setUploadFileMethod(uploadFile));
  }, []);

  const addPhoto = (event: React.ChangeEvent<HTMLInputElement>): void => {
    event.preventDefault();
    if (disabled) return;

    const { files } = event.currentTarget;
    if (files) {
      setUploadingPhoto(true);

      const processFiles = Array.from(files).map(async (file) => {
        if (file.type === 'image/heic') {
          try {
            const jpegBlob = await heicTo({
              blob: file,
              type: 'image/jpeg',
              quality: 0.85,
            });

            return new File([jpegBlob], file.name.replace(/\.heic$/i, '.jpeg'), {
              type: 'image/jpeg',
            });
          } catch (error: any) {
            toast.error(`Error converting HEIC file: ${error.message}`);
            return file;
          }
        }

        return file;
      });

      Promise.all(processFiles)
        .then((convertedFiles) => {
          Promise.all(convertedFiles.map(uploadFile))
            .then(() => {
              setUploadingPhoto(false);
            })
            .catch((error) => {
              toast.error(`Error uploading files: ${error.message}`);
              setUploadingPhoto(false);
            });
        })
        .catch((error) => {
          toast.error(`Error processing files: ${error.message}`);
          setUploadingPhoto(false);
        });
    }
  };

  const handleAttachmentOpen = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleAttachmentDownload = (url: string, filename?: string) => {
    const link = document.createElement('a');
    link.href = url;

    if ('download' in link) {
      link.download = filename || 'file';
      link.click();
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <>
      <div className={styles.collapsibleContentContainer}>
        {!disabled &&
          thisCase?.status !== 'completed' &&
          thisCase?.status !== 'canceled' &&
          !(
            userInfo.role.name === UserRoleName.CareAdvisor ||
            userInfo.role.name === UserRoleName.Admin ||
            userInfo.role.name === UserRoleName.SuperAdmin ||
            userInfo.role.name === UserRoleName.OrganizationAdmin
          ) && (
            <div className={styles.collapsibleAddPhoto}>
              <input
                name="selectedImages"
                type="file"
                id="formId"
                onChange={addPhoto}
                disabled={disabled}
                hidden
                multiple
                accept={CASE_ATTACHMENT_ACCEPT}
              />
            </div>
          )}
      </div>
      <div
        className={`${styles.collapsibleContentImages} ${
          checkCollapsibleHeaderColor(thisCase || '', userInfo, 'EditImages') === 'editImages' ||
          userInfo.role.name === UserRoleName.CareAdvisor ||
          userInfo.role.name === UserRoleName.Admin ||
          userInfo.role.name === UserRoleName.SuperAdmin ||
          userInfo.role.name === UserRoleName.OrganizationAdmin
            ? styles.noCursor
            : ''
        }`}
      >
        <div className={styles.galleryWrapperDiv}>
          <div className={styles.galleryWrapper}>
            {!isMobile ? (
              <>
                {images.slice(0, 5).map((image) => (
                  <div className={`fs-exclude ${styles.imageContainer}`} key={image.id}>
                    <div className={`${styles.imageCard} ${image.isSelected ? styles.selectedCard : ''}`}>
                      <img src={image.src} alt="" className={styles.image} loading="lazy" />

                      <div className={styles.editIcon} onClick={() => editNote(image.id!, image.src, disabled)}>
                        <BsPencil />
                      </div>

                      <div
                        className={`${styles.selectCircle} ${image.isSelected ? styles.selectedCircle : ''}`}
                        onClick={() => !disabled && handleSelect(image.id!)}
                      >
                        {image.isSelected && <span>✓</span>}
                      </div>

                      <div className={styles.imageDate}>{formatDate(image.created_at || '')}</div>
                    </div>
                  </div>
                ))}

                {images.length > 5 && (
                  <div
                    className={`fs-exclude ${styles.imageContainer}`}
                    onClick={() => {
                      if (images.length > 0) {
                        editNote(images[5].id!, images[5].src, disabled);
                      }
                    }}
                  >
                    <div
                      className={`${styles.imageCard} ${styles.viewAllCard}`}
                      style={{
                        backgroundImage: `url(${images[5].src})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        position: 'relative',
                      }}
                    >
                      <div className={styles.viewAllOverlay}>
                        <span>View all photos</span>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              images.map((image) => (
                <div className={`fs-exclude ${styles.imageContainer}`} key={image.id}>
                  <div className={`${styles.imageCard} ${image.isSelected ? styles.selectedCard : ''}`}>
                    <img src={image.src} alt="" className={styles.image} loading="lazy" />

                    <div className={styles.editIcon} onClick={() => editNote(image.id!, image.src, disabled)}>
                      <BsPencil />
                    </div>

                    <div
                      className={`${styles.selectCircle} ${image.isSelected ? styles.selectedCircle : ''}`}
                      onClick={() => !disabled && handleSelect(image.id!)}
                    >
                      {image.isSelected && <span>✓</span>}
                    </div>

                    <div className={styles.imageDate}>{formatDate(image.created_at || '')}</div>
                  </div>
                </div>
              ))
            )}
          </div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
              gap: '12px',
              alignItems: 'start',
              width: '100%',
            }}
          >
            {[...attachments]
              .sort((a, b) => {
                const dateA = new Date(a.created_at || '').getTime();
                const dateB = new Date(b.created_at || '').getTime();

                if (Number.isNaN(dateA) || Number.isNaN(dateB)) {
                  return Number(a.id || 0) - Number(b.id || 0);
                }

                return dateA - dateB;
              })
              .map((file) => (
                <div
                  className={`fs-exclude ${styles.imageContainer}`}
                  key={file.id}
                  style={{ width: '100%', margin: 0 }}
                >
                  <div className={styles.imageCard}>
                    <div className={styles.fileSquareContent}>
                      <InsertDriveFileIcon sx={{ fontSize: 50 }} />
                      <span className={styles.filename}>{truncateFilename(file.filename!, 20)}</span>
                    </div>

                    <div className={styles.attachmentOverlayActions}>
                      <IconButton size="small" onClick={() => handleAttachmentOpen(file.src)}>
                        <OpenInNewIcon fontSize="small" />
                      </IconButton>

                      {!disabled && (
                        <IconButton size="small" onClick={() => removeReportAttachment(file.id!, file.filename!)}>
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      )}
                    </div>

                    <div className={styles.imageDate}>{formatDate(file.created_at || '')}</div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ImagesSection;
